/* ------------------------------------------------------------------
 * Auth constants (shared client + server)
 * ------------------------------------------------------------------ */

/** HttpOnly cookie that stores the Firebase session cookie (14-day lifetime) */
export const SESSION_COOKIE = "netic_session";

/** HttpOnly cookie that stores the currently-selected tenant UUID */
export const TENANT_COOKIE = "netic_active_tenant";

/** Sentinel meaning “show data for *all* tenants” in UI state */
export const ALL_TENANTS_ID = "ALL";

/** 14 days expressed in *seconds* (Firebase + Set-Cookie) */
export const SESSION_MAX_AGE_SEC = 60 * 60 * 24 * 14;
